import React from "react";
/*import Select from 'react-select';*/
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import toUTCtime from "../../../../helper/UTCtime";
import { UpdatePropsMoveAsset } from "../../request.props.js";
import { PresenterMoveAsset } from "../../../presenter.js";
import FormHelper from "../../form.js";
import {
  ButtonValidation,
  ButtonCancel
} from "../../../../component/Button.js";
/*import Module from '../../../../utils/Render.js';*/
import SelectQuery from "../../../../component/SelectQuery.js";

export default class ModalMoveAsset extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      dueDate: moment().add(1, "d"),
      minDate: moment().add(1, "d"),
      clicked: false,
      is_process: false,
      SelectedItem: null,
      maxDate: null,
      currentLocation: null,
      isHaveDuedate: false,
      Site: "",
      Location: ""
    };
    this.state = Object.assign({}, this.initialState);

    this.isSiteSuggested = false;

    this.filterSiteList = this.filterSiteList.bind(this);
    this.onMoveSuccess = this.onMoveSuccess.bind(this);
    this.onMoveFailed = this.onMoveFailed.bind(this);
  }

  registerMove() {
    let DueDate = this.state.dueDate;

    DueDate._d.setHours(8);
    DueDate._d.setMinutes(59);
    DueDate._d.setSeconds(59);

    this.RegisterParams = {
      Location: this.state.Location,
      Site: this.state.Site,
      DueDate: toUTCtime(DueDate._d)
    };

    if (!FormHelper.ValidateFormMoveAsset(this.RegisterParams)) {
      return;
    }

    PresenterMoveAsset(
      UpdatePropsMoveAsset(this, this.onMoveSuccess, this.onMoveFailed)
    );
    this.setState({ is_process: true });
  }

  onMoveSuccess(params, response) {
    toast.success("Move success");
    this.props.closeModal();
    this.props.onMoveSuccess(response.data);
    this.setState({ is_process: false });
  }

  onMoveFailed(params, response) {
    this.setState({ is_process: false });
    toast.error(response.data.detail);
  }

  generateLabel(list, mapping) {
    // console.log(list.length)
    try {
      return list.map((val, key) => {
        if (mapping.label === "Username") {
          val.label = val.FirstName + " " + val.LastName;
        } else {
          val.label = val[mapping.label];
        }
        val.value = val[mapping.value];
        return val;
      });
    } catch (error) {
      if (list != null) {
        let val = [];
        val.value = list[mapping.value];
        val.label = list[mapping.label];
        return val;
      }
      return null;
    }
  }

  handleDueDateChange(date) {
    this.setState({
      dueDate: date
    });
  }

  handleSiteChange(event) {
    this.setState(
      {
        Location: "",
        Site: event.value,
        isHaveDuedate: !event.Category,
        clicked: true
      },
      () => this._location.reload("", true)
    );
  }

  handleLocationChange(event) {
    this.setState({
      Location: event.value,
      clicked: true
    });
  }

  filterSiteList(item) {
    if (
      !(
        this.props.UserReducer.props.isAdmin ||
        this.props.UserReducer.props.isStorage
      )
    ) {
      if (item.Category) {
        return false;
      }
    }
    return true;
  }

  getLocationBySite(site) {
    const { SelectedItem, MASTER_LOCATION } = this.state;
    try {
      return MASTER_LOCATION.filter((val, key) => {
        return val.Site === site && val.Alias !== SelectedItem.Location.Alias;
      });
    } catch (error) {
      // console.error(error);
    }
  }

  renderDueDate() {
    if (this.state.isHaveDuedate) {
      return (
        <div className="form-group col-sm-12">
          <label htmlFor="">Due Date</label>
          <DatePicker
            id="dueDate"
            name="Location"
            className="form-control"
            dateFormat="YYYY-MM-DD"
            // disabled={true}
            selected={this.state.dueDate}
            minDate={this.state.minDate}
            maxDate={this.state.maxDate}
            onChange={this.handleDueDateChange.bind(this)}
          />
        </div>
      );
    } else {
      return null;
    }
  }

  getCurrentLocation(val) {
    this.setState({
      currentLocation: {
        latitude: val.coords.latitude,
        longitude: val.coords.longitude
      }
    });
  }

  willMount() {
    // console.log(this)
    let dateObj = {
      maxDate: null
      // Site     	: {label:"", value:""},
      // Location    : {label:"", value:""},
    };
    const maxDayAsset = moment().add(this.state.SelectedItem.MaxDay, "d");
    // const nextReservation 	= this.state.SelectedItem.NextReservation;
    // if(nextReservation !== null){
    // 	const nextDate = moment(nextReservation.StartDate)
    // 	if(maxDayAsset < nextDate){
    dateObj.maxDate = maxDayAsset;
    // 	}else{
    // 		dateObj.maxDate = nextDate
    // 	}
    // }else{
    // 	dateObj.maxDate 	= maxDayAsset
    // }
    this.setState(dateObj);
  }

  willUnMount() {
    this.setState(this.initialState);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.SelectedItem !== null) {
      nextState.SelectedItem = nextProps.SelectedItem;
      return true;
    }
    return false;
  }

  render() {
    const { is_process } = this.state;

    if (
      this.state.SelectedItem === null ||
      this.state.SelectedItem === undefined
    ) {
      return null;
    }
    return (
      <Modal
        isOpen={this.props.isOpen}
        onEnter={() => this.willMount()}
        onExit={() => this.willUnMount()}
        toggle={this.props.closeModal}
      >
        <ModalHeader toggle={this.props.closeModal}>
          Move Asset / Tools
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="asset">Asset / Tools</label>
                <input
                  type="text"
                  className="form-control"
                  value={this.state.SelectedItem.Name}
                  disabled
                />
                <input
                  type="hidden"
                  className="form-control"
                  name="asset"
                  id="asset"
                  value={this.state.SelectedItem.Alias}
                />
              </div>
              <div className="row">
                <div className="form-group col-sm-6">
                  <label htmlFor="site">Site</label>
                  <SelectQuery
                    name="Site"
                    placeholder="Type Site"
                    value={this.state.Site}
                    urlKey="read-site-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    // filterOptions={(opt, str, val) => opt.filter(this.filterSiteList)}
                    onChange={val => this.handleSiteChange(val)}
                    UserReducer={this.props.UserReducer}
                    // disabled={!this.state.siteEdit}
                    // tabIndex="15"
                  />
                </div>
                <div className="form-group col-sm-6">
                  <label htmlFor="to">Location</label>
                  <SelectQuery
                    name="Location"
                    placeholder="Type Location"
                    value={this.state.Location}
                    urlKey="read-location-autocomplete"
                    valKey="Alias"
                    valLabel="Name"
                    extra={"site=" + this.state.Site}
                    onRef={asd => (this._location = asd)}
                    onChange={val => this.handleLocationChange(val)}
                    UserReducer={this.props.UserReducer}
                    // disabled={!this.state.siteEdit}
                    // tabIndex="16"
                  />
                </div>
                {this.renderDueDate()}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={this.props.closeModal}>Cancel</ButtonCancel>
          <ButtonValidation
            is_process={is_process}
            onClick={() => this.registerMove()}
          >
            Move
          </ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/home/helper/component/Modal/ModalMoveAsset.js